/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Form, Button, Tooltip, Alert } from "antd";
import moment from 'moment';
import { InfoCircleOutlined } from "@ant-design/icons";
import i18next from "i18next"
import { FormOutlined, RightOutlined } from '@ant-design/icons';
import _ from 'lodash';

import { camelCaseToTitle } from '../../helpers/StringHelper';
import { Styles, FormStyles } from './styles';
import { showHideForm } from "../../helpers/form";
import { GetFormItem, getFormTitles, getInputHeadLines, getInputLabel, propHasValue, showHideInput } from "./helper";
import Loading from "../Loading";
import dot from 'dot-object';
import { renderNestedInputs } from "./RenderForm";
import dayjs from "dayjs";
// import { inputConstruct, flatten, validateShownInputs, addComment } from "./helper";

export default function DynamicForm({
  form = {},
  data = {},
  disabledInputs = [],
  checkDuplicates = true,
  activeFormIndex: ind = '',
  onCancel,
  submit: onFinished = () => { },
  isFormDisabled = () => { return false },
  icons,
  module = 'pme',
  excludedKeys = [],
  showSaveAndNext = true,
  addressConfig = {},
}) {
  const formData = JSON.parse(JSON.stringify(data || {}))
  const [MainForm] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isChanged, setIsChanged] = useState(false);
  const [changedPath, setChangedPath] = useState([]);
  const [addressData, setAddress] = useState({});
  const [originalData, setOriginalData] = useState(formData);
  const [values, setValues] = useState(data || {});
  const [Forms, setForms] = useState([]);
  const [plainForms, setPlainForm] = useState({});
  const [activeFormIndex, setActiveFormIndex] = useState(Object.keys(form).includes(ind) ? ind : '');
  excludedKeys.push('icon', 'label', 'description', 'showFormIf', 'sectionLabel', 'formDescription', 'introText', 'alertConf', 'formTitles', 'position', 'excludeFromEdit', 'id');

  useEffect(() => {
    if (Forms && ind !== '' && Object.keys(form).includes(ind)) {
      setActiveFormIndex(ind);
      setSelectedForm(ind);
    }
  }, [ind])

  useEffect(() => {
    if (addressConfig && Object.keys(addressConfig).length > 0) {
      setAddress({
        address: addressConfig
      });
    }
  }, [addressConfig])

  useEffect(() => {
    if (Object.keys(form).length > 0) {
      const pForm = {};
      setForms(Object.keys(form).map((f, i) => {
        Object.keys(form[f]).filter(k => !excludedKeys.includes(k) && !form[f][k].excludeFromEdit).forEach(k => {
          pForm[k] = form[f][k];
        });
        return {
          id: f,
          name: form[f].label ? form[f].label : camelCaseToTitle(f),
          label: form[f].label ? form[f].label : camelCaseToTitle(f),
          description: form[f].formDescription ? form[f].formDescription : '',
          formTitles: form[f].formTitles || {},
          introText: form[f].introText ? form[f].introText : '',
          alertConf: form[f].alertConf ? form[f].alertConf : undefined,
          icon: form[f].icon && icons && icons[form[f].icon] ? icons[form[f].icon] : FormOutlined,
          selected: activeFormIndex === '' && i === 0 ? true : (f === activeFormIndex ? true : false),
          options: form[f],
          showFormIf: form[f].showFormIf,
          excludeFromEdit: form[f].excludeFromEdit,
          show: true,
        }
      }));
      setPlainForm({
        ...pForm
      })
    }
  }, [form]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setOriginalData(JSON.parse(JSON.stringify(data || {})));
      setValues(data)
      // MainForm.resetFields();
      // MainForm.setFieldsValue(data);
      // }
      // else {
      //   setOriginalData({});
      //   setValues({});
      //   MainForm.resetFields();
    }
  }, [data]);

  const setSelectedForm = (id) => {
    setForms(Forms.map(form => {
      (id === form.id)
        ? form.selected = true
        : form.selected = false;
      return form;
    }));
  }

  const isArrayOfObjects = (arr) => Array.isArray(arr) && arr
    .map(i => typeof i === 'object')
    .every(i => i);

  const hasNotChanged = (old, newData) => {
    return _.union(Object.keys(old), Object.keys(newData))
      .map(key => {
        switch (typeof newData[key]) {
          case undefined:
            return true;
          case 'object':
            try {
              if (moment.isMoment(newData[key])) {
                if (typeof newData[key].format === 'function') {
                  return old[key] === newData[key].format('YYYY-MM-DD');
                }
                return old[key] === dayjs(newData[key]._d).format('YYYY-MM-DD');
              } else if (isArrayOfObjects(newData[key])) {
                return newData[key].length === (old[key] || []).length && newData[key].map((oKey, i) => hasNotChanged((old[key] || [])[i] || {}, oKey || {})).every(i => i);
              }
            } catch (e) {
              console.log(e, values[key], key);
            }
            return _.isEqual(old[key], newData[key]);
          case 'number':
          case 'string':
          case 'boolean':
            return old[key] === newData[key];
          default:
            return true;
        }
      }).every(key => key);
  }

  const getData = (name, input, value, commentValue, path, disabledPath) => {
    const props = {
      placeholder: input.labelHint ? input.labelHint : getInputLabel(input, values, true),
      valueplaceholder: input.valueLabel || null,
      disabled: input.disabled || false,
      accept: input.accept || undefined,
    }
    if (disabledInputs.includes(disabledPath)) {
      props.disabled = true;
    }
    if (input.inputType === 'total100' && !value) {
      value = [{
        type: null,
        value: null
      }];
    } else if (['date', 'year'].includes(input.inputType)) {
      value = value ? dayjs(value) : undefined;
    } else if (input.inputType === 'switch') {
      if (!propHasValue(value)) {
        value = value || false;
        if (typeof path === 'string') {
          dot.str(path, value, values);
        }
      }
    } else if (input.inputType === 'upload' || input.inputType === 'imageUpload') {
      const fileList = (
        Array.isArray(value) ? value :
          (
            value &&
              typeof value === 'object' &&
              value.fileList &&
              Array.isArray(value.fileList) ?
              value.fileList.map(f => f.response).filter(f => f) : []
          )
      ) || [];
      if (!Array.isArray(value) && value &&
        typeof value === 'object' &&
        value.fileList &&
        Array.isArray(value.fileList)) {
        if (typeof path === 'string') {
          dot.set(path, fileList, values);
        }
      }
      value = fileList;
    }
    const config = {
      name,
      call: input.call,
      automaticallyLink: input.automaticallyLink,
      props,
      formsValue: values,
      onNewSetValue: input.onNewSetValue,
      multiple: input.multiple,
      updateOptions: input.updateOptions || false,
      options: input.options,
      optionGroup: input.optionGroup,
      optionsFilter: input.optionsFilter,
      filterCond: input.filterCond,
      disableOtherFields: input.disableOtherFields,
      updateOtherFields: input.updateOtherFields,
      repeatLabel: input.repeatLabel,
      unique: checkDuplicates ? input.unique : undefined,
      modalTitle: input.modalTitle,
      buttonText: input.buttonText,
      restricted: input.restricted || false,
      totalMax: input.totalMax,
      country: input.country || undefined,
      address: input.address || undefined,
      stakeholderId: input.stakeholderId,
      addressData,
      value,
      commentValue,
      commentHint: input.commentHint ? input.commentHint : i18next.t('Please specify'),
      rules: (input.rules || []).map(r => {
        if (r.message && r.message.indexOf('errors::') >= 0) {
          r.message = i18next.t(r.message);
        }
        return r;
      }),
      tags: input.tags,
    }

    if (input.inputType === 'switch' && input.autocomplete) {
      Object.assign(config, { autocomplete: input.autocomplete });
    }

    if (input.inputType === 'switch' && input.replace) {
      Object.assign(config, { replace: input.replace });
    }

    if (input.inputType === 'linkingModal') {
      Object.assign(config, {
        content: input.inputs
      });
    }

    if (input.inputType === 'group') {
      Object.assign(config, {
        groupInputs: Object.keys(input.groupInputs).map(key => {
          const isRep = path.split('.')[0].match(/\[/);
          const newPath = path.split('.').length === 1
            ? key : (isRep && isRep.length ? path.split('.')[0] + `.${key}` : path.split('.')[0] + `.${key}`);
          const groupInp = input.groupInputs[key];
          const inputData = getData(groupInp.dataId || key, input.groupInputs[key], dot.pick(newPath, values), null, newPath);
          return {
            path: newPath,
            type: input.groupInputs[key].inputType,
            data: inputData,
            forms: {
              form: MainForm,
              allForms: plainForms,
              values,
              setFormValues: setValues,
              setAddress
            },
          }
        }),
      });
    }

    return config;
  }

  const setSelectedFormNext = () => {
    let nextIndex = (Forms.indexOf(Forms.find(form => form.selected)) + 1);
    if (Forms[nextIndex]) {
      while (!filterForm(Forms[nextIndex])) {
        nextIndex += 1;
      }
      setActiveFormIndex(Forms[nextIndex].id);
      setSelectedForm(Forms[nextIndex].id);
    }
  }

  const onValuesChange = async (val, all) => {
    setValues({
      ...values,
      ...all
    });
    const keys = val && typeof val === 'object' ? Object.keys(val) : [];
    if (keys.length === 1) {
      const changedKey = keys[0];
      const ogData = originalData[changedKey];
      const newData = all[changedKey];
      let changePath = JSON.parse(JSON.stringify(changedPath));
      if (!hasNotChanged({ [changedKey]: ogData }, { [changedKey]: newData })) {
        if (!changePath.includes(changedKey)) {
          changePath.push(changedKey);
        }
      } else {
        changePath = changePath.filter(k => k !== changedKey);
      }
      setChangedPath([
        ...changePath
      ]);
      setIsChanged(changePath.length > 0 ? true : false);
    } else {
      setIsChanged(true);
    }
  }

  const getSelectedForm = () => {
    if (!Forms.length) return null;
    const selectedForm = Forms.find(f => f.selected) || Forms[0];
    const { id, options, introText, alertConf, formTitles } = selectedForm || {};
    return <Styles key={id} className="dynamic-form">
      <Form
        form={MainForm}
        autoComplete="new-password"
        key={id}
        onValuesChange={onValuesChange}
        name={id}
        layout="vertical"
        className="main-form">
        {introText && introText !== '' ? <p className="repeatable">{introText}</p> : null}
        {alertConf && typeof alertConf === "object" ? <Alert
          message={alertConf.text}
          type={alertConf.type}
          closable={alertConf.closable} /> : null}
        {Object.keys(options)
          .filter(k => !excludedKeys.includes(k) && !options[k].excludeFromEdit
            && showHideInput(options[k], values, undefined, undefined, setValues, k))
          .map((k, i) => {
            if (options[k].inputs) {
              return renderNestedInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
            } else {
              const input = options[k];
              const inputId = input.dataId || k;
              const value = values[inputId];
              const commentValue = values[`${inputId}Comment`];
              const inputData = getData(inputId, input, value, commentValue, inputId, inputId);
              const rules = inputData.rules ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max')) : [];
              const requiredRule = rules.find((r) => r.required);

              if (requiredRule && input.inputType === 'text') {
                rules.push({ whitespace: true, message: requiredRule.message || '' });
              }

              return showHideInput(input, values, undefined, undefined, setValues, inputId) ? <React.Fragment key={`${k}-${i}`}>
                {getFormTitles(formTitles, inputData.name, i)}
                {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                  getInputHeadLines(input.inputType, i, input, values)
                  :
                  <>
                    <GetFormItem
                      inputData={inputData}
                      inputId={inputId}
                      input={input}
                      values={values}
                      MainForm={MainForm}
                      options={options}
                      plainForms={plainForms}
                      setValues={setValues}
                      setAddress={setAddress}
                      onValuesChange={onValuesChange}
                      i={i}
                    />
                  </>
                }
              </React.Fragment> : null
            }
          })}
      </Form>
      <div className="form-botom">
        {/* {showSaveAndNext && (
          <Button type="dashed" className="mr-2" danger disabled={!isChanged || isSubmitting} htmlType="button" onClick={() => {
            // MainForm.setFieldsValue({
            //   ...originalData
            // });
            // setValues({
            //   ...originalData
            // });
            setIsChanged(false);
          }}>
            {i18next.t('Reset')}
          </Button>
        )} */}

        {showSaveAndNext && (
          <Button type="dashed" className="mr-2" loading={isSubmitting} disabled={!isChanged || isSubmitting} onClick={async (ev) => {
            ev.stopPropagation();
            const equal = hasNotChanged(originalData, values);
            setIsChanged(!equal);
            if (!equal) {
              submit(true).then(form => {
                if (onFinished) {
                  setIsSubmitting(true);
                  onFinished({ ...form, form: id }, (goNext = true) => {
                    setIsSubmitting(false);
                    if (goNext) {
                      setSelectedFormNext();
                    }
                  });
                }
                // setChangedPath([]);
                // setIsChanged(false);
              }).catch(err => console.log('errors', err));
            }
          }}>{i18next.t('Save and Continue')}</Button>
        )}
        <Button type="primary" loading={isSubmitting} disabled={!isChanged || isSubmitting} onClick={async (ev) => {
          ev.stopPropagation();
          const equal = hasNotChanged(originalData, values);
          setIsChanged(!equal);
          if (!equal) {
            submit().then(form => {
              if (onFinished) {
                setIsSubmitting(true);
                onFinished({ ...form, form: id }, () => {
                  setIsSubmitting(false);
                  return { isSave: true };
                }, true);
              }
              setChangedPath([]);
              setIsChanged(false);
            }).catch(err => console.log('errors', err));
          }
        }}>{i18next.t('Save')}</Button>
      </div>
    </Styles>
  }
  const filterForm = (f) => {
    return !f.excludeFromEdit && (f.showFormIf ? showHideForm(f, values) : true)
  }

  async function submit() {
    let d = {};
    const mainFormResult = await MainForm.validateFields();
    const currentForm = Forms.find(f => f.selected);
    if (currentForm) {
      Object.keys(mainFormResult).filter(f => Array.isArray(mainFormResult[f])).forEach(f => {
        if (currentForm.options[f] && currentForm.options[f].inputs && !currentForm.options[f].repeatable) {
          mainFormResult[f] = mainFormResult[f][0];
        }
      })
      if (mainFormResult) {
        // map filelist
        Object.keys(mainFormResult).forEach(key => {
          if (typeof mainFormResult[key] === 'object' && mainFormResult[key] !== null && propHasValue(mainFormResult[key])) {
            if (Object.keys(mainFormResult[key]).includes('fileList')) {
              const file = (mainFormResult[key].fileList || [])
                .map(file => file.response ? file.response : file)
                .filter(file => file && file.status === 'done')
                .concat(values[key] ? values[key] : [])
                .filter(file => file && file.status === 'done');
              mainFormResult[key] = !Array.isArray(file)
                ? file : file.filter((v, i, a) => a.indexOf(v) === i);
            } else {
              Object.keys(mainFormResult[key]).forEach(oKey => {
                if (typeof mainFormResult[key][oKey] === 'object' && mainFormResult[key][oKey] !== null && propHasValue(mainFormResult[key][oKey]) &&
                  Object.keys(mainFormResult[key][oKey]).includes('fileList')) {
                  const file = (mainFormResult[key][oKey].fileList || [])
                    .map(file => file.response ? file.response : file)
                    .filter(file => file && file.status === 'done')
                    .concat(values[key] ? values[key] : [])
                    .filter(file => file && file.status === 'done');
                  mainFormResult[key][oKey] = !Array.isArray(file)
                    ? file : file.filter((v, i, a) => a.indexOf(v) === i);
                }
              })
            }
          }
          if (Array.isArray(mainFormResult[key])) {
            // remove empty arrays
            mainFormResult[key] = mainFormResult[key].filter(f => typeof f !== 'object' || (Object.keys(f).length > 0 && Object.keys(f).filter(fk => propHasValue(f[fk])).length > 0));
          }
        });
      }
      Forms.forEach(form => {
        if (Object.keys(mainFormResult).includes(form.name)
          && form.component.name === 'total100') {
          mainFormResult[form.name] = form.value;
        }
      });
      Object.assign(d, { ...mainFormResult });
    }
    return { ...values, ...d };
  }
  return <FormStyles>
    {(Forms.length && Forms.length > 1) ? (
      <div className="forms">
        {Forms.filter(f => filterForm(f)).map(({ icon: Icon, ...form }, i) =>
          <Button
            key={form.id}
            type="link"
            size="large"
            block
            className={form.selected ? "active" : ""}
            onClick={() => setSelectedForm(form.id)}
            disabled={isFormDisabled()}>
            <Icon />
            <div className="flex flex-row justify-content-between">
              <div className="flex flex-column justify-content-center">
                <span>{getInputLabel(form, values)} {form.description ? <Tooltip title={form.description} placement="top">
                  <InfoCircleOutlined className="ml-1" />
                </Tooltip> : null}</span>
              </div>
              {form.selected && <RightOutlined />}
            </div>
          </Button>
        )}
      </div>
    ) : null}
    {isSubmitting ? <div className="form-loader"><Loading /></div> : null}
    <div className="form" style={{ minWidth: Forms.length <= 1 ? '100%' : '630px' }}>
      {(Forms.length && Forms.length >= 1) ? getSelectedForm() : null}
    </div>
  </FormStyles>

}
